@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.passwordValidationContainer {
  border-radius: 4px;
  padding-top: 16px;

  span {
    @include sm-sohne-medium;
    color: var(--Neutral-90, #2b2f38);
    font-weight: 400;
    line-height: 146%;
    padding-bottom: 2px;

    @include for-desktop-only {
      @include md-sohne;
      color: var(--dark-40);
    }
  }
}

.warning {
  display: inline;
  color: red;
  margin-left: 4px;

  @include for-desktop-only {
    color: #ae2222;
  }
}

.showPasswordButton {
  @include for-desktop-only {
    right: 8px;
    bottom: 8px;
  }
}

.requirementOptions {
  display: flex;
  align-items: center;
  display: flex;
  gap: 4px;
  color: var(--neutral-90);

  @include for-desktop-only {
    gap: 13px;

    span {
      color: var(--dark-90);
    }
  }

  @include for-tablet-portrait-max {
    gap: 4px;
    flex-direction: column;
    align-items: flex-start;
  }
}

.orangeCircle {
  border: 2px solid $yellow-50;
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  width: 8px;
  margin-right: 7px;
}

.passwordRequirement {
  display: flex;
  align-items: center;
  gap: 8px;
}

.errorText {
  @include sm-sohne-medium;
  color: var(--Neutral-90, #2b2f38);
  font-weight: 400;
  line-height: 146%;
}

.success {
  color: var(--positive-50);
}

.error {
  color: var(--negative-50);
}
